import { render, staticRenderFns } from "./TableComponent.vue?vue&type=template&id=6e2d3b92&scoped=true&"
import script from "./TableComponent.vue?vue&type=script&lang=ts&"
export * from "./TableComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TableComponent.vue?vue&type=style&index=0&id=6e2d3b92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2d3b92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VDialog,VIcon})
